import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

function initPolicyGallery() {
    const policyGallery = document.querySelector('.policy-gallery__swiper');

    if (!policyGallery) return;

    const swiper = new Swiper(policyGallery, {
        modules: [Navigation, Pagination, Autoplay],
        slidesPerView: 3,
        loop: true,
        spaceBetween: 9,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
        speed: 10000,
        allowTouchMove: false,
        breakpoints: {
            1199: {
                spaceBetween: 50,
            }
        }
    });
}

function preloaderAnimation() {
    const text = document.querySelector('.preloader__text');
    const logo = document.querySelector('.preloader__logo-container');

    if (!text) return;

    let tl = gsap.timeline({
        defaults: {
            duration: 1,
        }
    });
    tl.to(text, {
        opacity: 1,
    })
    .to(text, {
        opacity: 0,
        delay: 2,
    })
    .to(logo, {
        opacity: 1,
    })
    .to(logo, {
        opacity: 0,
        delay: 2,
    })
    .fromTo('.preloader', {
        background: 'linear-gradient(180deg, #143175 0%, #5770AA 100%)'
    }, {
        duration: 0.5,
        background: 'linear-gradient(180deg, #143175 0%, #143175 100%)',
        opacity: 0.8
    }, '<')
    .to('.preloader', {
        '--gradient-radius' : '250vh',
        '--gradient-offset' : '-10%',
    }, '<')
    .to('.preloader', {
        display : 'none'
    })
}

function heroMouseAnimation() {
    let ornaments = gsap.utils.toArray(".hero__ornament .ornament");

    if (!ornaments) return;

    function mouseMoveFunc(e) {
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        ornaments.forEach((ornament, index) => {
            const depth = 10;
            const moveX = (e.clientX - centerX) / depth;
            const moveY = (e.clientY - centerY) / depth;

            gsap.to(ornament, {
                x: moveX * (index + 1),
                y: moveY * (index + 1),
                overwrite: true
            });
        });
    }

    document.addEventListener("mousemove", mouseMoveFunc);
}

function aboutMouseAnimation() {
    let ornaments = gsap.utils.toArray(".about__ornament .ornament");

    if (!ornaments.length) return;

    function mouseMoveFunc(e) {
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        ornaments.forEach((ornament, index) => {
            const depth = 10;
            const moveX = (e.clientX - centerX) / depth;
            const moveY = (e.clientY - centerY) / depth;

            gsap.to(ornament, {
                x: moveX * (index + 1),
                y: moveY * (index + 1),
                overwrite: true
            });
        });
    }

    document.addEventListener("mousemove", mouseMoveFunc);
}

function companyMouseAnimation() {
    let ornaments = gsap.utils.toArray(".company__ornament .ornament");

    if (!ornaments.length) return;

    function mouseMoveFunc(e) {
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        ornaments.forEach((ornament, index) => {
            const depth = 10;
            const moveX = (e.clientX - centerX) / depth;
            const moveY = (e.clientY - centerY) / depth;

            gsap.to(ornament, {
                x: moveX * (index + 1),
                y: moveY * (index + 1),
                overwrite: true
            });
        });
    }

    document.addEventListener("mousemove", mouseMoveFunc);
}

function newsMouseAnimation() {
    let ornaments = gsap.utils.toArray(".news__ornament .ornament");

    if (!ornaments.length) return;

    function mouseMoveFunc(e) {
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;

        ornaments.forEach((ornament, index) => {
            const depth = 10;
            const moveX = (e.clientX - centerX) / depth;
            const moveY = (e.clientY - centerY) / depth;

            gsap.to(ornament, {
                x: moveX * (index + 1),
                y: moveY * (index + 1),
                overwrite: true
            });
        });
    }

    document.addEventListener("mousemove", mouseMoveFunc);
}

function showNavbar() {
    if (window.innerWidth >= 768) {
        gsap.fromTo('.custom-navbar', {
            opacity: 0
        }, {
            opacity: 1,
            scrollTrigger: {
                trigger: '.custom-navbar',
                start: 'top center',
                toggleActions: 'play none none reverse'
            }
        })
    }
}

function hideNavbar() {
    if (window.innerWidth >= 768) {
        gsap.fromTo('.custom-navbar', {
            opacity: 1
        }, {
            opacity: 0,
            scrollTrigger: {
                trigger: '.cta',
                start: 'top 15%',
                toggleActions: 'play none none reverse',
                // markers: true,
            }
        })
    }
}

function hideScrollButton() {
    gsap.to('.scroll-button', {
        opacity: 0,
        duration: 0.5,
        scrollTrigger: {
            trigger: '.footer',
            start: 'top bottom',
            toggleActions: 'play none none reverse'
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    initPolicyGallery();
    preloaderAnimation();
    heroMouseAnimation()
    aboutMouseAnimation()
    companyMouseAnimation()
    newsMouseAnimation()
    showNavbar()
    hideNavbar()
    // hideScrollButton()
})